import styles from './styles.module.scss'

import MasterCard from './logos/mastercard.svg'
import VISA from './logos/visa.svg'
import SEPA from './logos/sepa.svg'
import SWIFT from './logos/swift.svg'
import FasterPayments from './logos/faster_payments.svg'
import { useTranslation } from 'utils/use-translation'

const WIDGET_URL =
  // eslint-disable-next-line max-len
  'https://guardarian.com/calculator/v1?partner_api_token=9eeb5bb8-c2c7-4ea4-b2b2-bd96e52c6bf4&theme=light&type=narrow&default_fiat_amount=90&default_fiat_currency=USD&default_crypto_currency=USDT&to_network=TRX&without_box_shadow=true&'
export default function CashOutPage() {
  const { t } = useTranslation()
  
  return (
    <>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.text}>
            <p className={styles.subtitle}>{t('buy_or_sell_crypto')}</p>
            <p className={styles.subtitle}>{t('invest_in_dreams')}</p>
            <ul className={styles.cons}>
              <li className={styles.con}>{t('zero_extra_costs')}</li>
              <li className={styles.con}>{t('fast_friendly_verification')}</li>
              <li className={styles.con}>{t('payment_options')}</li>
            </ul>

            <div className={styles['payment-methods']}>
              <img src={MasterCard} alt="MasterCard logo" className={styles['payment-method']} />
              <img src={VISA} alt="VISA logo" className={styles['payment-method']} />
              <img src={SEPA} alt="SEPA logo" className={styles['payment-method']} />
              <img src={SWIFT} alt="SWIFT logo" className={styles['payment-method']} />
              <img src={FasterPayments} alt="Faster Payments logo" className={styles['payment-method']} />
            </div>
          </div>
          <iframe className={styles.widget} src={WIDGET_URL}></iframe>
        </div>
      </div>
    </>
  )
}
